// Centralized JWT token storage. Backwards-compat reads the legacy `portal_token`
// key (the single-token scheme used before refresh tokens were introduced) and
// migrates it forward on first use.

const ACCESS_KEY  = 'portal_access_token';
const REFRESH_KEY = 'portal_refresh_token';
const LEGACY_KEY  = 'portal_token';

export function getAccessToken() {
  return localStorage.getItem(ACCESS_KEY) || localStorage.getItem(LEGACY_KEY);
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_KEY);
}

export function setTokens({ accessToken, refreshToken }) {
  if (accessToken) {
    localStorage.setItem(ACCESS_KEY, accessToken);
    // Keep legacy key in sync so any old code path still works during rollout.
    localStorage.setItem(LEGACY_KEY, accessToken);
  }
  if (refreshToken) {
    localStorage.setItem(REFRESH_KEY, refreshToken);
  }
}

export function clearTokens() {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(LEGACY_KEY);
}

export function decodeJwt(token) {
  if (!token) return null;
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return null;
  }
}
